import { Button } from '@mui/material';
import LayersIcon from '@mui/icons-material/Layers';
import { useContext } from './context';

export function LayerButton({ sx }) {
  const { isOpen, toggleOpen } = useContext();

  return (
    <Button
      title="Layer List"
      variant="contained"
      color="inherit"
      onClick={toggleOpen}
      sx={{
        pointerEvents: 'auto',
        minWidth: 0,
        bgcolor: 'white',
        mb: 1,
        '@media (hover: none)': { '&:hover': { bgcolor: 'white' } },
        ...sx,
      }}
    >
      <LayersIcon
        fontSize="medium"
        sx={{
          color: isOpen ? 'black' : '#666',
          '@media (hover: hover)': { '&:hover': { color: '#333' } },
        }}
      />
    </Button>
  );
}
